import { all, takeLatest } from 'lib/redux';
import { placeOrderSaga, validateCreditCard } from 'features/placeOrder/PlaceOrder.saga';
import {
  LOAD_FINALIZE_ORDER_PAGE,
  GET_ESTIMATED_COST,
  PLACE_ORDER,
  VALIDATE_CREDIT_CARD,
  LOAD_UPGRADE_REPORT_FINALIZE_ORDER,
} from '../../constants/ActionTypes';
import {
  loadFinalizeOrderSaga, getEstimatedCostSaga, loadUpgradeReportFinalizeOrderSaga,
} from './FinalizeOrder.saga';

/**
 * Defines the watchers related to FinalizeOrder Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(PLACE_ORDER, placeOrderSaga),
    takeLatest(LOAD_FINALIZE_ORDER_PAGE, loadFinalizeOrderSaga),
    takeLatest(LOAD_UPGRADE_REPORT_FINALIZE_ORDER, loadUpgradeReportFinalizeOrderSaga),
    takeLatest(GET_ESTIMATED_COST, getEstimatedCostSaga),
    takeLatest(VALIDATE_CREDIT_CARD, validateCreditCard),
  ]);
}
